import { useCallback } from 'react';
import { scrollToTop } from 'site-modules/personalized-search/utils/scroll-to-top';
import { INVENTORY_SCROLL_TO_TOP_ANCHOR } from 'site-modules/personalized-search/constants/inventory';

const DRAWER_CSS_TRANSITION_TIMEOUT = 300;

export function useScrollOnDrawerHide() {
  const onDrawerHide = useCallback(() => {
    setTimeout(() => {
      scrollToTop(INVENTORY_SCROLL_TO_TOP_ANCHOR);
    }, DRAWER_CSS_TRANSITION_TIMEOUT);
  }, []);

  return { onDrawerHide };
}
